import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import Link from 'react-router-dom/Link';
import './menu.css';

class Menu extends PureComponent {
    static propTypes = {
        isAdmin: PropTypes.bool,
        isCoach: PropTypes.bool,
        isExecutive: PropTypes.bool,
        isOpened: PropTypes.bool.isRequired,
        profileData: PropTypes.object.isRequired,
        location: PropTypes.object,
    }

    componentWillMount() {
        const group = this.props.profileData.group;

        this.links = {
            admin: [
                {
                    path: '/group/list',
                    icon: 'fa-users',
                    text: 'Groups',
                    urls: ['/group'],
                },
                {
                    path: '/pla/list',
                    icon: 'fa-user',
                    text: 'Primary Plans',
                    urls: ['/pla'],
                },
                {
                    path: '/sla/list',
                    icon: 'fa-calendar-o',
                    text: 'Secondary Plans',
                    urls: ['/sla'],
                },
                {
                    path: '/survey/list',
                    icon: 'fa-comments-o',
                    text: 'Feedback Surveys',
                    urls: ['/survey'],
                },
                {
                    path: '/documents/diagnostics',
                    icon: 'fa-file-o',
                    text: 'Documents',
                    urls: ['/documents'],
                },
                {
                    path: '/assignments/dashboard',
                    icon: 'fa-video-camera',
                    text: 'Assignments',
                    urls: ['/assignments'],
                },
                {
                    path: '/se/list',
                    icon: 'fa-envelope',
                    text: 'System Email',
                    urls: ['/se'],
                },
                {
                    path: '/templates',
                    icon: 'fa-file-text-o',
                    text: 'Text Templates',
                    urls: ['/templates'],
                },
                {
                    path: '/coaches/list',
                    icon: 'fa-address-book',
                    text: 'Coaches',
                    urls: ['/coaches'],
                }
            ],
            coach: [
                {
                    path: '/assignments/feedbacks',
                    icon: 'fa-video-camera',
                    text: 'Assignments',
                    urls: ['/assignments'],
                }
            ],
            user: [
                {
                    path: '/pla/initial',
                    icon: 'fa-user-o',
                    text: group ? (group.primary_agenda_name || 'Personal Leadership Agenda') : 'Personal Leadership Agenda',
                    urls: ['/pla'],
                },
                {
                    path: '/sla/initial',
                    icon: 'fa-calendar-o',
                    text: group ? (group.secondary_agenda_name || 'Secondary Plan') : 'Secondary Plan',
                    urls: ['/sla'],
                },
                {
                    path: '/survey',
                    icon: 'fa-comments-o',
                    text: group ? (group.feedback_survey_name || 'Feedback Surveys') : 'Feedback Surveys',
                    urls: ['/survey'],
                },
                {
                    path: '/documents/diagnostics',
                    icon: 'fa-file-o',
                    text: group ? (group.documents_name || 'Documents') : 'Documents',
                    urls: ['/documents'],
                },
                {
                    path: '/journals',
                    icon: 'fa-address-book-o',
                    text: group ? (group.journals_name || 'Insights Journal') : 'Insights Journal',
                    urls: ['/journals'],
                },
                {
                    path: '/assignments/upload',
                    icon: 'fa-video-camera',
                    text: 'Assignments',
                    urls: ['/assignments'],
                }
            ]
        };
    }

    renderLinks(type) {
        return this.links[type].map((link, index) => {
            const path = this.props.location.pathname;

            let isActive = false;

            link.urls.forEach((url) => {
                if (path.indexOf(url) !== -1) {
                    isActive = true;
                }
            });

            return (
                <li key={`men_${index}`}>
                    <Link to={link.path} className={`menu-link${isActive ? ' active' : ''}`}><i className={`fa ${link.icon}`} /> {link.text}</Link>
                </li>
            );
        });
    }

    render() {
        const type = this.props.isAdmin ? 'admin' : (this.props.isCoach ? 'coach' : 'user');

        return (
            <div className={`main-menu ${this.props.isOpened ? 'active' : ''}`}>
                <ul className={this.links[type].length > 1 ? 'centered' : ''}>
                    {this.renderLinks(type)}
                </ul>
            </div>
        );
    }
}

function mapStateToProps({ MainMenu, authentication }) {
    return {
        isOpened: MainMenu.showMenu,
        isAdmin: authentication.isAdmin,
        isCoach: authentication.isCoach,
        isExecutive: authentication.isExecutive
    };
}

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/TopBar/Menu.js